/* AFS B2B — PDP: variant selection, gallery, quote form prefill,
   recently-viewed recording. */
(function () {
  'use strict';

  var root = document.querySelector('[data-product-root]');
  if (!root) return;

  var productJson = document.getElementById('ProductJson');
  var product = null;
  try { product = productJson ? JSON.parse(productJson.textContent) : null; } catch (e) { /* noop */ }

  if (root.dataset.handle && window.AFSRecentlyViewed) {
    window.AFSRecentlyViewed.record(root.dataset.handle);
  }

  /* ---------- Gallery ---------- */
  var mainImg = root.querySelector('[data-gallery-main] img');
  root.querySelectorAll('[data-gallery-thumb]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (!mainImg) return;
      mainImg.src = btn.getAttribute('data-src');
      mainImg.srcset = btn.getAttribute('data-srcset') || '';
      mainImg.alt = btn.getAttribute('data-alt') || mainImg.alt;
      root.querySelectorAll('[data-gallery-thumb]').forEach(function (b) {
        b.setAttribute('aria-current', String(b === btn));
      });
    });
  });

  /* ---------- Variant selection ---------- */
  var variantSelect = root.querySelector('[data-variant-select]');
  var idInput = root.querySelector('form[data-ajax-add] [name="id"]');

  function findVariant(id) {
    if (!product) return null;
    return product.variants.find(function (v) { return String(v.id) === String(id); }) || null;
  }

  function formatMoney(cents) {
    var format = (window.AFSConfig && window.AFSConfig.moneyFormat) || '${{amount}}';
    var amount = (cents / 100).toFixed(2);
    return format.replace(/\{\{\s*amount\s*\}\}/, amount).replace(/<[^>]+>/g, '');
  }

  if (variantSelect) {
    variantSelect.addEventListener('change', function () {
      var variant = findVariant(variantSelect.value);
      if (!variant) return;
      if (idInput) idInput.value = variant.id;
      var priceEl = root.querySelector('[data-variant-price]');
      if (priceEl && root.dataset.priceState === 'public') priceEl.textContent = formatMoney(variant.price);
      var skuEl = root.querySelector('[data-variant-sku]');
      if (skuEl && variant.sku) skuEl.textContent = variant.sku;
      var availEl = root.querySelector('[data-variant-availability]');
      if (availEl) {
        availEl.textContent = variant.available ? availEl.getAttribute('data-in-stock') : availEl.getAttribute('data-unavailable');
      }
      var addBtn = root.querySelector('form[data-ajax-add] [type="submit"]');
      if (addBtn) addBtn.disabled = !variant.available;
      // Keep quote/list buttons in sync
      root.querySelectorAll('[data-add-to-quote], [data-add-to-list]').forEach(function (btn) {
        try {
          var data = JSON.parse(btn.getAttribute('data-product'));
          data.variantId = variant.id;
          if (variant.sku) data.sku = variant.sku;
          btn.setAttribute('data-product', JSON.stringify(data));
        } catch (err) { /* noop */ }
      });
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    });
  }

  /* ---------- Lazy product recommendations ---------- */
  var recEl = document.querySelector('[data-product-recommendations]');
  if (recEl && recEl.dataset.url) {
    fetch(recEl.dataset.url)
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var incoming = doc.querySelector('[data-product-recommendations] .container') || doc.querySelector('.section .container');
        if (incoming) { recEl.innerHTML = '<div class="container">' + incoming.innerHTML + '</div>'; }
        else { recEl.remove(); }
      })
      .catch(function () { recEl.remove(); });
  }

  /* ---------- Product-level quote form prefill (scope §8) ---------- */
  var quoteToggle = root.querySelector('[data-pdp-quote-toggle]');
  var quoteForm = root.querySelector('[data-pdp-quote-form]');
  if (quoteToggle && quoteForm) {
    quoteToggle.addEventListener('click', function () {
      var open = !quoteForm.hidden;
      quoteForm.hidden = open;
      quoteToggle.setAttribute('aria-expanded', String(!open));
      if (!open) {
        var urlField = quoteForm.querySelector('[data-quote-page-url]');
        if (urlField) urlField.value = window.location.href;
        var qty = root.querySelector('input[name="quantity"]');
        var qtyField = quoteForm.querySelector('[data-quote-qty]');
        if (qty && qtyField && !qtyField.value) qtyField.value = qty.value;
        var variantField = quoteForm.querySelector('[data-quote-variant]');
        if (variantField && idInput) variantField.value = idInput.value;
        var first = quoteForm.querySelector('input:not([type="hidden"]), select, textarea');
        if (first) first.focus();
      }
    });
  }
})();
